module.exports = __webpack_public_path__ + "img/20191004163907360截图20191004163311635.3a6e21b7.jpg";